import {requests} from "../../utils/helpers/api.services";
import {COMPANY_URL} from "../../utils/helpers/api.routes";

export const CompanyService = {
    getCompany: () => requests.get(COMPANY_URL),
    updateCompany: (body: FormData) => requests.put(`${COMPANY_URL}`, body),
    deleteCompanyDocument: (id: number) => requests.delete(`${COMPANY_URL}/document/${id}`)
}